<template>
  <div id="icon_footer"
       v-if="iconIsShow">
    <img src="../../assets/img/icon_footer.png" />
  </div>
</template>
<script>
export default {
  name: 'G-i-footer',
  data () {
    return {
      msg: '技术支持-阿中软件'
    }
  },
  props: {
    iconIsShow: {
      type: Boolean,
      default: true
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped>
#icon_footer {
  text-align: center;
  position: fixed;
  bottom: 36px;
  width: 100%;
  z-index: 0;
}
#icon_footer > img {
  width: 54%;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobleIconFooter/index.vue